export { default } from './MessageWithResponseButtonsContent';
